export default __webpack_public_path__ + "static/media/Contracts.913c0e22.svg";